import React, { useState } from 'react';
import { Grade, GroundType, DistanceType } from '../../GameConstants/GameValues';
import { useTranslation } from 'react-i18next';
import { Search, X } from 'lucide-react';
import CustomSelect from '../shared/CustomSelect';

const RaceSearch = ({ onSearch }) => {
    const { t } = useTranslation();
    const [name, setName] = useState('');
    const [grade, setGrade] = useState('');
    const [surface, setSurface] = useState('');
    const [distanceType, setDistanceType] = useState('');

    const handleSearch = () => {
        onSearch({
            name,
            grade,
            surface,
            distanceType
        });
    };

    const handleReset = () => {
        setName('');
        setGrade('');
        setSurface('');
        setDistanceType('');
        onSearch({});
    };

    // Prepare options for CustomSelect
    const gradeOptions = [
        { value: "", label: t('RaceSearch.option_all_grades') },
        ...Object.entries(Grade).map(([key, value]) => ({ value: key, label: value }))
    ];

    const surfaceOptions = [
        { value: "", label: t('RaceSearch.option_all_surfaces') },
        ...Object.entries(GroundType).map(([key, value]) => ({ value: key, label: value }))
    ];

    const distanceOptions = [
        { value: "", label: t('RaceSearch.option_all_distances') },
        ...Object.entries(DistanceType).map(([key, value]) => ({ value: key, label: value }))
    ];

    return (
        <div className="bg-white dark:bg-gray-800 p-5 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 mb-8 sticky top-4 z-30">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">

                {/* Name Filter */}
                <div className="space-y-1">
                    <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wide">
                        {t('RaceSearch.label_name')}
                    </label>
                    <div className="relative">
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder={t('RaceSearch.placeholder_name')}
                            className="w-full pl-9 px-3 py-2.5 bg-gray-50 dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all dark:text-white text-sm"
                        />
                        <Search className="w-4 h-4 absolute left-3 top-3 text-gray-400" />
                    </div>
                </div>

                {/* Grade Filter */}
                <CustomSelect
                    label={t('RaceSearch.label_grade')}
                    value={grade}
                    onChange={setGrade}
                    options={gradeOptions}
                    placeholder={t('RaceSearch.option_all_grades')}
                />

                {/* Surface Filter */}
                <CustomSelect
                    label={t('RaceSearch.label_surface')}
                    value={surface}
                    onChange={setSurface}
                    options={surfaceOptions}
                    placeholder={t('RaceSearch.option_all_surfaces')}
                />

                {/* Distance Filter */}
                <CustomSelect
                    label={t('RaceSearch.label_distance')}
                    value={distanceType}
                    onChange={setDistanceType}
                    options={distanceOptions}
                    placeholder={t('RaceSearch.option_all_distances')}
                />
            </div>

            {/* Buttons */}
            <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-200 dark:border-gray-700">
                <button
                    onClick={handleReset}
                    className="px-4 py-2 text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white transition-colors flex items-center gap-1 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700"
                >
                    <X className="w-4 h-4" /> {t('RaceSearch.button_reset')}
                </button>
                <button
                    onClick={handleSearch}
                    className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg shadow-md hover:shadow-lg transition-all transform hover:-translate-y-0.5 active:translate-y-0 text-sm"
                >
                    {t('RaceSearch.button_apply')}
                </button>
            </div>
        </div>
    );
};

export default RaceSearch;
